import { ActionTypes } from '../constants/actionTypes';

const initialState = {
    loading: false,
    toastMessage: {
        open: false,
        message: "",
        status: ""
    },
   drawerOpen : false,
   editDrawerOpen: false,
   isEdit: false,
   confimationAlert: false,
   confirmCancel: false,
   formData: {
    first_name: "",
    last_name: "", 
    user_id: "",
    role_id:"1",
    site_id: [],
    created_by:"",
   },
   errors:{},
   active: false
}

export const userManagementReducer = (state= initialState, {type, payload}) => {
  switch(type) {
    case ActionTypes.SET_ADD_COLLEAGUE_DRAWER_OPEN:
        return{...state, drawerOpen: payload};
    case ActionTypes.SET_EDIT_COLLEAGUE_DRAWER_OPEN:
        return{...state, editDrawerOpen: payload};
    case ActionTypes.SET_CONFIRMATION_ALERT:
         return{...state, confimationAlert: payload}
    case ActionTypes.SET_CONFIRMATION_ACTION:
        return{...state, confirmCancel: payload}
    case ActionTypes.RESET_CONFIRMATION_ACTION:
            return{...state, confirmCancel: payload}
    case ActionTypes.SET_COLLEAGUE_FORMDATA:
        return{
            ...state,
            formData: {
                ...state.formData,
                [payload.field]: payload.value
            }
        }
    case ActionTypes.RESET_COLLEAGUE_FORMDATA:
    case ActionTypes.RESET_EDITFORM_DEFAULT_ENTRIES:
        return{
            ...state,
            formData: initialState.formData
            }
    case ActionTypes.SET_EDITFORM_DEFAULT_ENTRIES: 
    return {
        ...state,
        formData: {
            ...payload,
            // building_name: [
            //     payload.building_name,
            // ],
        },
    };
    case ActionTypes.SET_FORMFIELD_ERRORS:
        return {
            ...state,
            errors :{
                ...state.errors,
                [payload.field]: payload.value
            }
        }
    case ActionTypes.RESET_FORMFIELD_ERRORS:
        return {
            ...state,
            errors: {}
        }
    case ActionTypes.ADD_COLLEAGUE_REQUEST:
        case ActionTypes.UPDATE_COLLEAGUE_REQUEST:
        return {
            ...state,
            loading: true,
            toastMessage: {
                    ...state.toastMessage,
                    open: payload.open,
                    message: payload.message,
                    status: payload.status
                }
        }
    case ActionTypes.POST_ADD_COLLEAGUE_SUCCESS:
        return {
            ...state,
            loading: false,
        }
    case ActionTypes.POST_ADD_COLLEAGUE_FAILURE:
        return {
            ...state,
            loading: false
        }
    case ActionTypes.STATUS_TOASTMESSAGE:
    case ActionTypes.CLOSE_STATUS_TOASTMESSAGE:
            return{
                ...state,
                toastMessage: {
                    ...state.toastMessage,
                    open: payload.open,
                    message: payload.message,
                    status: payload.status
                }
            }
            case ActionTypes.TOGGLE_USER_ACTIVE_STATUS:
        return {
            ...state,
            loading: false,
            active: !state.active
        }
    default:
    return state;
  }
}